export default __webpack_public_path__ + "static/media/1 zuTTkJe54Wv907enmQt46g.34123b98.png";